import React from 'react'
import { Form, Row, Radio } from 'antd'
import { FormInstance } from 'antd/lib/form'
interface Props {
  form: FormInstance
  required?: boolean // 校验
  onFieldsChange: () => void
}
// 原始图否可用
const Originalpic: React.FC<Props> = (props) => {
  const { form, required, onFieldsChange } = props
  const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
  }
  const itemLayou = {
    style: {
      width: '20%',
      marginBottom: '10px',
    },
  }
  return (
    <Form
      {...formItemLayout}
      form={form}
      onFieldsChange={onFieldsChange}
      labelAlign="right"
      colon={false}
      style={{ margin: '10px 0 0 0', padding: '0 10px 0 0' }}
      size="small"
    >
      <Row>
        <Form.Item
          name="orgpic"
          label="关系"
          {...itemLayou}
          rules={[{ required: required, message: '请选择图片关系' }]}
        >
          <Radio.Group style={{ width: '100%' }}>
            <Radio value={'1'}>可用</Radio>
            <Radio value={'0'}>不可用</Radio>
          </Radio.Group>
        </Form.Item>
      </Row>
    </Form>
  )
}

export default Originalpic
import React from 'react'
import { Form, Row, Radio } from 'antd'
import { FormInstance } from 'antd/lib/form'
interface Props {
  form: FormInstance
  required?: boolean // 校验
  onFieldsChange: () => void
}
// 原始图否可用
const Originalpic: React.FC<Props> = (props) => {
  const { form, required, onFieldsChange } = props
  const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
  }
  const itemLayou = {
    style: {
      width: '20%',
      marginBottom: '10px',
    },
  }
  return (
    <Form
      {...formItemLayout}
      form={form}
      onFieldsChange={onFieldsChange}
      labelAlign="right"
      colon={false}
      style={{ margin: '10px 0 0 0', padding: '0 10px 0 0' }}
      size="small"
    >
      <Row>
        <Form.Item
          name="orgpic"
          label="关系"
          {...itemLayou}
          rules={[{ required: required, message: '请选择图片关系' }]}
        >
          <Radio.Group style={{ width: '100%' }}>
            <Radio value={'1'}>可用</Radio>
            <Radio value={'0'}>不可用</Radio>
          </Radio.Group>
        </Form.Item>
      </Row>
    </Form>
  )
}

export default Originalpic
